import { Loading, useAppRouter } from "@sgi/af-shell-shared";
import { Navigate, RouterProvider } from "react-router-dom";

export default function AppWithRouter() {
  const router = useAppRouter({
    rootRoutes: [
      {
        path: '/',
        element: <Navigate to="/claims" />
       }
      ],
  });

  return <RouterProvider router={router} fallbackElement={<Loading />} />;
}
